/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_SubtitleInputs */

const cs_integrations_subtitle = /** @type {(inputs: Integrations_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firemní produkty: Sreality RK, katastr, exekuce. Osobní kalendáře jsou na profilu každého makléře — ne tady.`)
};

const en_integrations_subtitle = /** @type {(inputs: Integrations_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office products: Sreality RK, cadastre, executions. Personal calendars are on each broker’s profile — not here.`)
};

/**
* | output |
* | --- |
* | "Office products: Sreality RK, cadastre, executions. Personal calendars are on each broker’s profile — not here." |
*
* @param {Integrations_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_subtitle = /** @type {((inputs?: Integrations_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_subtitle(inputs)
	return cs_integrations_subtitle(inputs)
});